import { ANGLES_D_OUVERTURE, COURAGES } from './listes.js';
/**
 * **Le contexte d'un geste fait dans l'app** (chantier journal-des-gestes, ticket 05) : l'app dit
 * avec chaque requête l'appareil (`useAuPouce`), l'angle affiché et, pour un geste parti de
 * Maintenant, le courage choisi, dans les en-têtes `EN_TETES_DU_CONTEXTE`. Le serveur les écrit
 * sur la ligne du journal des gestes quand la porte est `toi`, et seulement s'ils sont de ces
 * listes fermées : une valeur venue de dehors, sinon vide.
 *
 * Et les lectures que l'app signale (`LECTURES_DE_L_APP`) : ouvrir et fermer un projet ou une
 * fiche, changer d'angle. Écrit ici, une fois, pour le serveur et l'app.
 */
/** L'appareil : l'écran du téléphone (moins de 720 px) ou celui de l'ordinateur. */
export const APPAREILS = ['ordinateur', 'telephone'];
/**
 * Les angles qu'une feuille peut montrer (la bascule de la feuille, `client/src/projets/angles.ts`) :
 * les trois d'ouverture, puis Maintenant et Agenda.
 */
export const ANGLES_AFFICHES = [...ANGLES_D_OUVERTURE, 'maintenant', 'agenda'];
/** Les en-têtes du contexte, en minuscules (Node les rend ainsi). */
export const EN_TETES_DU_CONTEXTE = {
    appareil: 'x-nextilt-appareil',
    angle: 'x-nextilt-angle',
    courage: 'x-nextilt-courage',
};
/**
 * Les lectures que l'app signale à `POST /api/journal/lecture`. Et, depuis le chantier
 * liens-entre-bulles (ticket 03), la touche A de la carte : montrer les liens cachés, puis les
 * recacher, sur la feuille montrée.
 */
export const LECTURES_DE_L_APP = [
    'ouvrir_projet',
    'fermer_projet',
    'ouvrir_fiche',
    'fermer_fiche',
    'changer_angle',
    'montrer_liens_caches',
    'recacher_liens_caches',
];
function deLaListe(liste, valeur) {
    return liste.includes(valeur) ? valeur : null;
}
/** L'appareil dit, s'il est de la liste ; `null` sinon (absent, inconnu, mal écrit). */
export function appareilDeLaListe(valeur) {
    return deLaListe(APPAREILS, valeur);
}
/** L'angle dit, s'il est de la liste ; `null` sinon. */
export function angleDeLaListe(valeur) {
    return deLaListe(ANGLES_AFFICHES, valeur);
}
/** Le courage dit, s'il est de la liste (`COURAGES`, celui de Maintenant) ; `null` sinon. */
export function courageDeLaListe(valeur) {
    return deLaListe(COURAGES, valeur);
}
